import { c as _c } from "react/compiler-runtime";
import React, { createContext, ReactNode, useContext, useState } from 'react';
export interface CLPContext {
  isReviewsModalOpen: boolean;
  openReviewsModal: () => void;
  closeReviewsModal: () => void;
  toggleReviewsModal: () => void;
}
const CLPContext = createContext<CLPContext | undefined>(undefined);
interface ClpContextProviderProps {
  children: ReactNode;
}
export const ClpContextProvider: React.FC<ClpContextProviderProps> = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [isReviewsModalOpen, setIsReviewsModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsReviewsModalOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openReviewsModal = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsReviewsModalOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeReviewsModal = t2;
  let t3;
  if ($[2] !== isReviewsModalOpen) {
    t3 = () => setIsReviewsModalOpen(!isReviewsModalOpen);
    $[2] = isReviewsModalOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const toggleReviewsModal = t3;
  let t4;
  if ($[4] !== isReviewsModalOpen || $[5] !== toggleReviewsModal) {
    t4 = {
      isReviewsModalOpen,
      openReviewsModal,
      closeReviewsModal,
      toggleReviewsModal
    };
    $[4] = isReviewsModalOpen;
    $[5] = toggleReviewsModal;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t4) {
    t5 = <CLPContext.Provider value={t4}>{children}</CLPContext.Provider>;
    $[7] = children;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export function useClpContext() {
  const context = useContext(CLPContext);
  if (!context) {
    throw new Error("useClpContext must be used within a ClpContextProvider");
  }
  return context;
}